// extracted by mini-css-extract-plugin
module.exports = {"section":"HeroSection_section___O62n","herotext":"HeroSection_herotext__1bp75"};